/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CancelAction from './CancelAction/index'
import DoneAction from './DoneAction/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Info from './Info/index'
import LinkAction from './LinkAction/index'
import Password from './Password/index'
import QrCode from 'DesignSystem/QrCode/react'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/SignAction/Content/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let payorContractSignatureRequestIdValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'contract.signature_request.id',
})
let aggregateData = fromHelpers.getSignatureRequestUrl(payorContractSignatureRequestIdValueData)
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="View signature request"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 gap={dtSpaceS}
>
{childProps => (
<React.Fragment>
<Info
{...childProps}
  viewPath={`${viewPath}/Info`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="You can use the link below and use one of the dates of birth to access the contract."
/>
<LinkAction
  viewPath={`${viewPath}/LinkAction`}
/>
<Password
  viewPath={`${viewPath}/Password`}
/>
</div>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 width="45%"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="or"
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 width="45%"
/>
</div>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Scan the QR code with your phone camera to access the contract."
/>
<QrCode
{...childProps}
  viewPath={`${viewPath}/QrCode`}
 marginLeft="auto"
 marginRight="auto"
 marginTop={0}
 size={206}
 data="payor.contract.signature_request.id"
 aggregate="helpers.js getSignatureRequestUrl"
 value={aggregateData}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<DoneAction
{...childProps}
  viewPath={`${viewPath}/DoneAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}